import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { SpeciesGroupService } from '../proxy/general/controllers/species-group.service';

FieldBuilder.setNamespace('General');

export const SPECIESGROUPCHIPCUBICMETERCOEFFICIENT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('coefficientValue', 'Entity.SpeciesGroupChipCubicMeterCoefficient.CoefficientValue')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .date('validSince', 'Entity.SpeciesGroupChipCubicMeterCoefficient.ValidSince')
    .required()
    .build(),
  FieldBuilder.foreignKey(
    'speciesGroupId',
    'Entity.SpeciesGroup',
    SpeciesGroupService
  )
    .required()
    .displayFromNested('speciesGroup.name')
    .sortBy('speciesGroup.name')
    .build(),
];

export const SPECIESGROUPCHIPCUBICMETERCOEFFICIENT_CONFIG = {
  entityName: 'SpeciesGroupChipCubicMeterCoefficient',
  localizationKey: 'General::Entity.SpeciesGroupChipCubicMeterCoefficient',
  fields: SPECIESGROUPCHIPCUBICMETERCOEFFICIENT_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.SpeciesGroupChipCubicMeterCoefficients',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
